/**
 * Bakım görünümünde sekme: başlık "Bakımda · DENT-OS", favicon'un sağ alt köşesinde yanıp sönen
 * amber nokta. Yeni bir görsel dosyası yoktur: yayının kendi `favicon-32.png`si tuvale çizilir ve
 * nokta üstüne eklenir (CSP `img-src data:` izinli, infra/caddy/Caddyfile). Hareket azaltma
 * tercihinde nokta sabit durur. Dönen işlev eski favicon'u ve başlığı geri koyar.
 */
import type { MaintenanceAudience } from './maintenance-screen.js';

export const MAINTENANCE_TITLE = 'Bakımda · DENT-OS';

/** Hastanın sayfasında sekme satıcı adı taşımaz (2 Ekim 2026, ürün sahibi). */
export function maintenanceTitle(audience: MaintenanceAudience): string {
  return audience === 'public' ? 'Bakımda' : MAINTENANCE_TITLE;
}
const ICON_URL = '/favicon-32.png';
const DOT = '#D9930F';

export function startMaintenanceFavicon(
  reducedMotion: boolean,
  audience: MaintenanceAudience = 'clinic',
): () => void {
  const links = [...document.querySelectorAll<HTMLLinkElement>('link[rel~="icon"]')];
  const originals = links.map((link) => ({ link, href: link.getAttribute('href') }));
  const originalTitle = document.title;
  document.title = maintenanceTitle(audience);
  let stopped = false;
  let timer: ReturnType<typeof setInterval> | null = null;
  const apply = (href: string) => {
    for (const link of links) link.setAttribute('href', href);
  };

  const image = new Image();
  image.onload = () => {
    if (stopped) return;
    const canvas = document.createElement('canvas');
    canvas.width = 32;
    canvas.height = 32;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(image, 0, 0, 32, 32);
    const plain = canvas.toDataURL('image/png');
    // Beyaz halka noktayı logonun koyu zemininden ayırır (tasarımdaki 1,5 px kenar).
    ctx.beginPath();
    ctx.arc(25, 25, 7, 0, Math.PI * 2);
    ctx.fillStyle = '#FFFFFF';
    ctx.fill();
    ctx.beginPath();
    ctx.arc(25, 25, 5, 0, Math.PI * 2);
    ctx.fillStyle = DOT;
    ctx.fill();
    const dotted = canvas.toDataURL('image/png');
    apply(dotted);
    if (reducedMotion) return;
    let lit = true;
    timer = setInterval(() => {
      lit = !lit;
      apply(lit ? dotted : plain);
    }, 1000);
  };
  image.src = ICON_URL;

  return () => {
    stopped = true;
    if (timer !== null) clearInterval(timer);
    for (const { link, href } of originals) {
      if (href === null) link.removeAttribute('href');
      else link.setAttribute('href', href);
    }
    document.title = originalTitle;
  };
}
